import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractActionService } from '../../../../core/service/v2/service/action/abstractAction.service';
import { CustomizeHttpUrlGenerator } from '../../../../../store/core/url/customizeHttpUrlGenerator';
import { WorkflowApplicationTaskExecutePayload } from './payload/workflowApplicationTaskExecute.payload';
import {WorkflowTaskModel} from "../../api/model/common/workflowTask.model";
import {WorkflowTaskConverter} from "../../api/model/common/converter/workflowTask.converter";

@Injectable()
export class WorkflowApplicationTaskExecuteService extends AbstractActionService<WorkflowApplicationTaskExecutePayload, WorkflowTaskModel> {

    public constructor(
        customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
        httpClient: HttpClient,
        private converter: WorkflowTaskConverter) {
        super('WorkflowTask', 'execute', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): WorkflowTaskModel {
        return this.converter.convert(response);
    }
}
